import { getByMouvementClient } from '@/api/lettrage/index';

export default async function getDetailEcheancePaiement(idEcheance) {
  const detailEcheancePaiement = [];
  const lettrages = (await getByMouvementClient(idEcheance)).data.result;
  lettrages.forEach((lettrage) => {
    let mouvementReglement = lettrage.mouvementClient1;
    if (lettrage.mouvementClient1Id === idEcheance) {
      mouvementReglement = lettrage.mouvementClient2;
    }
    detailEcheancePaiement.push({
      dateReglement: mouvementReglement.dateMouvement,
      montant: lettrage.montant,
      modeReglementId: mouvementReglement.remiseBancaire
        ? mouvementReglement.remiseBancaire.modeReglementId : null,
      referenceReglement: mouvementReglement.ligneRemiseBancairePseudoEntity.referenceReglement,
      idRemiseBancaire: mouvementReglement.remiseBancaire
        ? mouvementReglement.remiseBancaire.id : null,
      idFacture: mouvementReglement.facture ? mouvementReglement.facture.id : null,
      sousType: mouvementReglement.facture ? mouvementReglement.facture.sousType : null,
      typeDePiece: mouvementReglement.typeDePiece,
      libelle: mouvementReglement.libelle,
    });
  });
  return detailEcheancePaiement;
}
